$(function(){
    AOS.init({
        once:true,
        disable:'mobile'
    });
});



(function ($)
    { "use strict"

    /* 2. sticky And Scroll UP */
    $(window).on('scroll', function () {
        var scroll = $(window).scrollTop();
        if (scroll < 100) {
            $(".header-sticky").removeClass("sticky-bar");
            $('#back-top').fadeOut(500);
        } else {
            $(".header-sticky").addClass("sticky-bar");
            $('#back-top').fadeIn(500);
        }
    });
// Scroll Up
$('#back-top a').on("click", function () {
    $('body,html').animate({
        scrollTop: 0
    }, 800);
    return false;
});


/* 3. slick Nav */
// mobile_menu
var menu = $('ul.navigation');
if(menu.length){
    menu.slicknav({
        prependTo: ".mobile_menu",
        closedSymbol: '+',
        openedSymbol:'-'
       
    });
};
// Onload Popup
// $(window).on('load',function(){
//     $('#myNewsletter').modal('show');
// });
     

// Delayed Modal Display + Cookie On Click
// $(document).ready(function() {
// 	var addaa = $.cookie("no_thanks");
//   console.log(addaa);
//   console.log(typeof addaa);
//   // If no cookie with our chosen name (e.g. no_thanks)...
//   if (addaa != 'true') {
// 		console.log('here');
//     // Show the modal, with delay func.
//     $('#myNewsletter').appendTo("body");
//     function show_modal1(){
// //       $('#myNewsletter').modal();
//       $('#myNewsletter').modal('show');
//     }

//     // Set delay func. time in milliseconds
//     window.setTimeout(show_modal1, 3000);
//     }

//   // On click of specified class (e.g. 'nothanks'), trigger cookie, which expires in 100 years
//   $("#newsletter_mail").on('submit',function() {
//     $.cookie('no_thanks', 'true', { expires: 36500});
// //     document.cookie = "no_thanks=true; expires=Fri, 31 Dec 9999 23:59:59 UTC";
//   });
// });

     $(".menu-2").on('click',function() {
       	$('#myNewsletter').modal('show'); 
     });
     
})(jQuery);

// Qty Cart
// function incrementQty() {
//   var value = document.querySelector('input[name="qty"]').value;
//   var cardQty = document.querySelector(".cart-qty");
//   value = isNaN(value) ? 1 : value;
//   value++;
//   document.querySelector('input[name="qty"]').value = value;
//   cardQty.innerHTML = value;
//   cardQty.classList.add("rotate-x");
// }

// function decrementQty() {
//   var value = document.querySelector('input[name="qty"]').value;
//   var cardQty = document.querySelector(".cart-qty");
//   value = isNaN(value) ? 1 : value;
//   value > 1 ? value-- : value;
//   document.querySelector('input[name="qty"]').value = value;
//   cardQty.innerHTML = value;
//   cardQty.classList.add("rotate-x");
// }

// function removeAnimation(e) {
//   e.target.classList.remove("rotate-x");
// }

// const counter = document.querySelector(".cart-qty");
// counter.addEventListener("animationend", removeAnimation);

 $(document).ready(function(){
        $('ul.slicknav_nav').append('<a href="https://www.instagram.com/sevenmilefarms/" target="_blank" class="instagram_icon d-md-none"><i class="fa fa-instagram"></i></a>');
    });

// 21+ Year

function getCookie(cname){
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i=0; i<ca.length; i++) 
      {
      var c = ca[i].trim();
      if (c.indexOf(name)==0) return c.substring(name.length,c.length);
      }
    return "";
}

jQuery(document).ready(function($) {
	if ($.cookie('hide-div')) {
    	$("#close-me").remove();
    }

    $("#Inrto21").click(function() {
        $("#close-me").remove();
        $.cookie('hide-div', true);
    });
});

jQuery(window).on('load',function(){
      var twenty = getCookie("hide-div");
      if (twenty == 'true') {
        jQuery(".intro_banner").remove();
      }
});
